import { LOCALE } from "../../../properties/Locale";
import * as yup from "yup";

export const professionalPracticeValidator = yup.object().shape({
  title: yup.string().required(LOCALE.title + LOCALE.required_field),
  description: yup
    .string()
    .required(LOCALE.description + LOCALE.required_field),
  attachments: yup.array().required(LOCALE.proof + LOCALE.required_field),
});
